<template>
  <div class="price_list" :class="[{ hidden: !showOption }, type]">
    <ul class="list_option_wrap">
      <li
        v-for="(option, idx) in ebookOptions"
        :key="idx"
        :class="{
          'on': idx === selectedOption,
          'hidden': option.salePrice == '0'
        }"
        @click="activeListOpt(idx), selectPurchaseOption(option)"
      >
        <button class="list_option">
          <span class="opt_desc">
            {{ option.optDesc }}
          </span>
          <span class="ar" :class="{ rent: idx > 0 }">
            <vue-intl-numberformat
              class="price"
              locale="ko-KR"
              format-style="decimal"
              :currency="getCurrency.currency"
              :number="option.salePrice"
            />
            <span>원</span>
            <span v-if="(option.rate > 0)" class="opt_rate">
              ({{ option.rate }}%↓)
            </span>
          </span>
        </button>
      </li>
    </ul>
    <transition name="modal-fade">
      <Modal v-if="showCartModal" @close="toggleModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <div class="msgimg">
                  <!-- <span class="svg_msg_cart"></span> -->
                  <img
                    src="@/assets/images/svg/ico_popup_cart.svg"
                    class="svg_msg_cart"
                    alt="carticon"
                  />
                </div>
                <span class="cart_alert_msg">{{
                  $t('views.store.bookdetail.7074')
                }}</span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn mr" @click="toggleModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
                <button class="box_btn dull" @click="navigateToCart">
                  <span class="an_t">
                    {{ $t('views.store.bookdetail.2771') }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { CART_ADD_ITEM, CART_GET_LIST } from '@/store/types'
export default {
  name: 'OptionList',
  props: {
    book: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedOption: null,
      selectedOptions: [],
      showOption: false,
      showCartModal: false
    }
  },
  computed: {
    ...mapGetters(['getCurrency', 'getCurrentUser']),
    ebookOptions() {
      if (this.book.bookPrice?.ebook?.options) {
        return this.book.bookPrice.ebook.options
      }
      return 0
    },
    bookTp() {
      if (this.book?.bookTp === 'BUNDLE') {
        return 'BUNDLE'
      }
      return 'BOOK'
    }
  },
  methods: {
    activeListOpt(idx) {
      this.selectedOption = idx
    },
    selectPurchaseOption(option) {
      this.selectedOptions = []
      this.selectedOptions.push({ ...option })

      if (this.getCurrentUser) {
        this.addToCart()
      } else {
        alert('로그인이 필요한 서비스 입니다')
      }
    },
    formatCartData() {
      const items = {
        purchase: {
          cartBooksList: [
            {
              buyOptTp: 'PMT',
              buyAmt: 1,
              bookTp: this.bookTp,
              buyTp: {
                paperbook: false,
                ebook: true,
                pod: false
              },
              bookPrice: {
                paperbook: 0,
                ebook: {
                  optId: this.selectedOptions[0].optId,
                  price: Number(this.selectedOptions[0].salePrice)
                },
                pod: { profileId: null }
              }
            }
          ]
        }
      }
      return items
    },
    async addToCart() {
      const item = this.formatCartData()
      try {
        await this.$store.dispatch(CART_ADD_ITEM, {
          id: this.book.bookCd,
          item
        })
        this.$store.dispatch(CART_GET_LIST)

        if (this.type === 'cart') {
          this.showCartModal = true
        } else if (this.type === 'buy') {
          this.navigateToCart()
        }
      } catch (err) {
        console.log(err)
        alert('이미 장바구니에 담겨 있는 상품입니다')
      }
    },
    hideOption() {
      this.showOption = false
    },
    toggleShowOption() {
      this.showOption = !this.showOption
    },
    toggleModal() {
      this.showCartModal = !this.showCartModal
    },
    navigateToCart() {
      this.$router.push({ name: 'cart' })
    }
  }
}
</script>
<style lang="scss" scoped>
.price_list {
  max-width: 200px;
  .list_option_wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 200px;
    width: 192px;
    z-index: 1;
    li {
      border: 1px solid #cdd7fa;
      // border-radius: 3px;
      background-color: #ffffff;
      // text-align: center;
    }
    li.on {
      background-color: #e9f4ff;
      // color: #ffffff;
    }
    li:hover {
      background-color: #e9f4ff;
      // color: #ffffff;
    }
    .list_option {
      padding: 0 5px;
      min-height: 30px;
      span {
        text-align: left;
      }
    }
    .opt_desc {
      // display: block;
      display: inline-block;
      width: 70px;
      font-weight: 400;
      font-size: 12px;
    }
    .ar {
      position: inherit;
      // display: block;
    }
    .ar.rent {
      color: #eb6243;
    }
    .price {
      display: inline !important;
      font-weight: 700;
      margin-right: 0 !important;
    }
    .opt_rate {
      font-size: 13px;
      display: inline !important;
      // color: #ff0000;
    }
  }
}
.ly_inner {
  .cell {
    height: 100%;
    padding-bottom: 24px;
  }
  .btn_wrap {
    display: flex;
    justify-content: center;
    .box_btn {
      width: 50%;
      height: 56px;
      &.mr {
        margin-right: 10px;
      }
      .an_t {
        font-family: 'pretendard-medium';
        font-weight: 600;
        font-size: 18px;
        line-height: 56px;
        letter-spacing: 0;
      }
    }
  }
}
.svg_msg_cart {
  width: 64px;
  height: 64px;
  background: none;
  margin-bottom: 24px;
}
.cart_alert_msg,
.cart_desc_head {
  font-weight: 600;
  font-size: 30px;
  color: #008df3;
}
@media all and (max-width: 767px) {
  .price_list {
    .list_option_wrap {
      // width: 150px;
      width: 100px;
      .opt_desc {
        margin-bottom: 3px;
        // padding-bottom: 5px;
        font-weight: 600;
        font-size: 13px;
      }
      .list_option {
        span {
          text-align: center;
        }
      }
      li {
        padding: 10px 0px;
        font-size: 16px;
      }
    }
  }
  .cart_alert_msg,
  .cart_desc_head {
    // font-family: ;
    font-weight: 700;
    font-size: 24px;
  }
}
</style>
